/** Align with LOS BorrowerV2: Pre-qual letter menu only for purchase loans. */
export const showPrequalLetterMenuV2 = (application) =>
    application?.property?.purpose === "purchase"
